const pricingFAQData = [
    {
      question: "How do you determine the cost of a project?",
      answer: "The cost of a project depends on several factors, including the scope of work, materials used, project complexity, and labor involved. We provide detailed estimates after an initial consultation and site assessment.",
    },
    {
      question: "Do you offer free consultations and estimates?",
      answer: "Yes, we offer free initial consultations and detailed estimates to help you understand the potential costs involved in your project.",
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept various payment methods, including bank transfers, checks, and credit/debit cards. We can discuss payment schedules during the project planning phase.",
    },
    {
      question: "Are there any hidden costs or fees?",
      answer: "We believe in transparency and strive to provide accurate and comprehensive estimates. We will discuss all potential costs upfront, and any changes will be communicated and approved by you.",
    },
    {
      question: "Do you offer any financing options?",
      answer: "We don't directly offer financing options, but we can provide information on potential financing sources or work with your chosen financial institution.",
    },
    {
      question: "What is included in the project cost?",
      answer: "The project cost typically includes materials, labor, permits (if applicable), and project management. We will provide a detailed breakdown in your estimate.",
    },
    {
      question: "How do you handle changes to the project scope and cost?",
      answer: "Any changes to the project scope will be discussed and documented in a change order, which will include any adjustments to the cost and timeline. We require your approval before proceeding with any changes.",
    },
    {
      question: "Are your prices competitive?",
      answer: "We strive to offer competitive pricing while maintaining high-quality workmanship and materials. We believe in providing value for your investment.",
    },
    {
      question: "Do you offer any discounts or promotions?",
      answer: "We may offer occasional discounts or promotions. Please inquire about any current offers during your consultation.",
    },
    {
      question: "What happens if the project exceeds the estimated cost?",
      answer: "We will communicate any potential cost overruns as soon as possible and provide options for addressing them. We will not proceed with any additional work without your approval.",
    },
  ];
  
  export default pricingFAQData;